import { MigrateFunctionBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { modelVersion, modelVersions } from '../__generated/model/index.js';
import { migrateToV2 } from './v02.js';
export const migrations = {
    '2': migrateToV2
};
export const migrate = MigrateFunctionBuilder.fromVersions(modelVersions).to(modelVersion).using(migrations).build();

//# sourceMappingURL=index.js.map